import Image from "next/image";
import {
  Marquee,
  MarqueeContent,
  MarqueeFade,
} from "@/components/ui/shadcn-io/marquee";
import { fontSizes } from "@/constants/constants";
import { ButtonCta, LiveChatButton } from "@/components";
const BooksMarquee = ({ items, classStyle, title, text, sliderStyle }) => {
  return (
    <div className="flex w-full  ">
      <div
        className={`${classStyle}  flex flex-col items-center justify-center text-center w-full  `}
      >
        {items[0]?.name && (
          <div className="py-10">
            <h1 className={`${fontSizes.text_4_xl} font-bold`}>{title}</h1>
            <p>{text}</p>
          </div>
        )}
        <div className="w-full relative overflow-hidden">
          <Marquee>
            <MarqueeContent pauseOnHover className="[--duration:30s] ">
              <div
                className={`flex ${sliderStyle} ${
                  items[0]?.cta && "gap-8 md:gap-20"
                }`}
              >
                {Array.isArray(items) &&
                  items.map((item, index) => (
                    <div
                      key={index}
                      className={`flex justify-center items-center ${
                        items[0]?.name && "flex-col"
                      }`}
                    >
                      <Image
                        className={`h-auto max-w-full ${
                          !item.name ? "bg-contain" : ""
                        }`}
                        src={item?.image}
                        alt={item?.name}
                      />
                      <p className="py-4">{items[0]?.cta && item?.name}</p>
                    </div>
                  ))}
                <div className="w-16" />
              </div>
            </MarqueeContent>

            <MarqueeFade side="left" />
            <MarqueeFade side="right" />
          </Marquee>

          <div className="pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-background"></div>
          <div className="pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l from-background"></div>
        </div>
        {items[0]?.name && items[0]?.cta && (
          <div className="flex gap-4 py-10  ">
            <LiveChatButton
              buttonText="Live Chat"
              classStyle={`text-[#fff] bg-[#1EA7DB] hover:bg-[#1EA7DB]/90 h-12 `}
            />
            <ButtonCta
              buttonText="Get a Quote"
              classStyle={`text-[#fff] bg-[#61C1E5] hover:bg-[#61C1E5]/90 h-12 `}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BooksMarquee;
